import { useTranslate } from '@tolgee/react';
import TeamTopPlayersPage, {
  getServerSideProps as fetcher,
  TeamTopPlayersPageProps,
} from '@amf/shared/pages/TeamTopPlayersPage';

import Meta from 'components/Meta';
import Layout from 'components/layout/Layout';
import { AppLinks } from 'utils/links';

export default function Page({ navigation, partners, team, seasons }: TeamTopPlayersPageProps) {
  const { t } = useTranslate();
  return (
    <div className='TeamTopPlayers'>
      <Layout navigation={navigation} partners={partners}>
        <Meta title={t('stats.team.title', { team: team.name })} />
        <TeamTopPlayersPage team={team} seasons={seasons} prefixes={{ player: AppLinks.player }} />
      </Layout>
    </div>
  );
}

export const getServerSideProps = fetcher();
